import React, { useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import Avatar from '../../../base/avatar/components/Avatar';
import { translate } from '../../../base/i18n/functions';
import { withPixelLineHeight } from '../../../base/styles/functions.web';
import ListItem from '../../../base/ui/components/web/ListItem';
import { ACTION_TRIGGER, AudioPinkStateIcons, MEDIA_STATE, QUICK_ACTION_BUTTON, VideoPinkStateIcons } from '../../constants.any';
import { MEDIA_TYPE } from '../../../base/media/constants';
import { getParticipantByIdOrUndefined, getRoleParticipant, isLocalParticipantModerator, isParticipantModerator } from '../../../base/participants/functions';
import { isForceMuted } from '../../functions';
import ParticipantQuickAction from './ParticipantQuickAction';
import { isInBreakoutRoom } from '../../../breakout-rooms/functions';
import Icon from '../../../base/icons/components/Icon';
import { IconVerified } from '../../../base/icons/svg';
import { useSelector } from 'react-redux';
import { getKnockingParticipants } from '../../../lobby/functions';
const useStyles = makeStyles()(theme => {
    return {
        nameContainer: {
            display: 'flex',
            flex: 1,
            overflow: 'hidden',
            fontWeight: 500
        },
        name: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontWeight: 500
        },
        moderatorLabel: {
            ...withPixelLineHeight(theme.typography.labelBold),
            color: theme.palette.redP01
        },
        avatar: {
            marginRight: theme.spacing(3)
        },
        avatarCustom: {
            marginLeft: "8px",
            marginRight: '6px'
        }
    };
});
/**
 * A component representing a participant entry in ParticipantPane and Lobby.
 *
 * @param {IProps} props - The props of the component.
 * @returns {ReactNode}
 */
function ParticipantItem({ actionsTrigger = ACTION_TRIGGER.HOVER, audioMediaState = MEDIA_STATE.NONE, children, disableModeratorIndicator, displayName, isHighlighted, isModerator, local, onLeave, openDrawerForParticipant, overflowDrawer, participantID, raisedHand, t, videoMediaState = MEDIA_STATE.NONE, youText, muteAudio, stopVideo, isRaisedHand }) {
    const state = APP.store.getState();
    const participant = getParticipantByIdOrUndefined(state, participantID);
    const onClick = useCallback(() => openDrawerForParticipant?.({
        participantID,
        displayName
    }), []);
    const { classes } = useStyles();
    const userRole = getRoleParticipant(state, participantID);
    const checkEmail = (participantId) => {
        let part;
        if (participantId?.includes('-')) {
            part = getParticipantByIdOrUndefined(state, participantId.split("-")[0]);
        }
        else {
            part = getParticipantByIdOrUndefined(state, participantId);
        }
        return part?.email;
    };
    const icon = (React.createElement("div", null,
        React.createElement(Avatar, { className: classes.avatarCustom, displayName: displayName, participantId: participantID?.includes('-') ? participantID.split("-")[0] : participantID, size: 32 }),
        checkEmail(participantID) && React.createElement(Icon, { style: { position: 'absolute', bottom: "7px", left: "27px" }, src: IconVerified, size: 12, color: 'transparent' })));
    const text = (React.createElement("div", null,
        React.createElement("div", { className: classes.nameContainer },
            React.createElement("div", { className: classes.name }, displayName),
            local ? React.createElement("span", null,
                "\u00A0(",
                youText,
                ")") : null),
        isModerator && !disableModeratorIndicator && React.createElement("div", { className: classes.moderatorLabel }, t(`menuController.${getRoleParticipant(state, participantID)}`))));
    // const _isVideoMuted = isParticipantVideoMuted(participant, state);
    const _isVideoForceMuted = isForceMuted(participant, MEDIA_TYPE.VIDEO, state);
    const _quickActionVideoButtonType = _isVideoForceMuted ? QUICK_ACTION_BUTTON.ALLOW_VIDEO : QUICK_ACTION_BUTTON.STOP_VIDEO;
    // const _isAudioMuted = isParticipantAudioMuted(participant, state);
    const _isAudioForceMuted = isForceMuted(participant, MEDIA_TYPE.AUDIO, state);
    const _quickActionAudioButtonType = _isAudioForceMuted ? QUICK_ACTION_BUTTON.ASK_TO_UNMUTE : QUICK_ACTION_BUTTON.MUTE;
    const participants = useSelector(getKnockingParticipants);
    const participantIds = participants?.map(e => e.id);
    const isLocalModerator = isLocalParticipantModerator(APP.store.getState());
    let indicators = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: isModerator ? "audio-moderator" : (isLocalModerator ? "audio" : "audio-normal") },
            !isRaisedHand && AudioPinkStateIcons[audioMediaState],
            !local
                && isLocalParticipantModerator(state)
                && !isParticipantModerator(participant)
                && !overflowDrawer
                && !participantIds?.includes(participantID)
                // && !participant?.isFakeParticipant
                && !isInBreakoutRoom(state)
                && !participantID.includes("-")
                && !isRaisedHand
                && (React.createElement(ParticipantQuickAction, { buttonType: _quickActionAudioButtonType, participantID: participantID, participantName: displayName || '', muteAudio: muteAudio || (() => { }), stopVideo: stopVideo || (() => { }) }))),
        React.createElement("div", { className: (isModerator || disableModeratorIndicator) ? "video-moderator" : (isLocalModerator ? "video" : "video-normal") },
            !isRaisedHand && VideoPinkStateIcons[videoMediaState],
            !local
                && isLocalParticipantModerator(state)
                && !isParticipantModerator(participant)
                && !overflowDrawer
                && !participantIds?.includes(participantID)
                // && !participant?.isFakeParticipant
                && !isInBreakoutRoom(state)
                && !participantID.includes("-")
                && !isRaisedHand
                && (React.createElement(ParticipantQuickAction, { buttonType: _quickActionVideoButtonType, participantID: participantID, participantName: displayName || '', muteAudio: muteAudio || (() => { }), stopVideo: stopVideo || (() => { }) })))));
    if (isRaisedHand) {
        indicators = React.createElement(React.Fragment, null);
    }
    return (React.createElement(ListItem, { isModerator: isModerator, local: local, actions: children, hideActions: local, icon: icon, id: `participant-item-${participantID}`, indicators: indicators, isHighlighted: isHighlighted, onClick: !local ? onClick : undefined, onMouseLeave: onLeave, textChildren: text, trigger: actionsTrigger, isRaisedHand: isRaisedHand, participantID: participantID }));
}
export default translate(ParticipantItem);
